import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";

const CustomListItem = styled(ListItem)(({ theme, open }) => ({
  width: "100%",
  borderRadius: 10,
  display: "flex",
  alignItems: "center",
  "& .MuiListItemIcon-root": {
    marginRight: open ? theme.spacing(2) : theme.spacing(1),
    justifyContent: "center",
  },
  "&.Mui-selected": {
    background: "linear-gradient(90deg, #00BB9F, #B0EE93)",
    color: "#fff",
    "& .MuiListItemIcon-root": {
      color: "#fff",
    },
    "&:hover": {
      background: "linear-gradient(90deg, #00BB9F, #B0EE93)",
    },
  },
  "&:not(.Mui-selected):hover": {
    color: "#00BB9F",
    "& .MuiListItemIcon-root": {
      color: "#00BB9F",
    },
  },
}));

export default CustomListItem;
